import React from 'react'
import { Card, Input, Space, Button, Select, Spin } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useCategories } from '../hooks/useCategories'
import { useCategoryActions } from '../hooks/useCategoryActions'
import { CategoriesTable } from '../components/CategoriesTable'
import { CategoryDetailsDrawer } from '../components/CategoryDetailsDrawer'
import { CategoryFormModal } from '../components/CategoryFormModal'

const { Option } = Select

export const CategoriesScreen: React.FC = () => {
    const {
        categories,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        isLoading,
        isFetching
    } = useCategories()

    const {
        selectedCategory,
        isDetailDrawerOpen,
        isFormModalOpen,
        editingCategory,
        handleViewDetails,
        handleAddCategory,
        handleEditCategory,
        handleDeleteCategory,
        handleFormSubmit,
        closeDrawer,
        closeFormModal,
        isSubmitting,
    } = useCategoryActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search categories..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Option value="all">All Status</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAddCategory}>
                        Add Category
                    </Button>
                </Space>

                <Spin spinning={isLoading || isFetching}>
                    <CategoriesTable
                        categories={categories}
                        onRowClick={handleViewDetails}
                        onEdit={handleEditCategory}
                        onDelete={handleDeleteCategory}
                    />
                </Spin>
            </Card>

            <CategoryDetailsDrawer
                category={selectedCategory}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onEdit={handleEditCategory}
                onDelete={handleDeleteCategory}
            />

            <CategoryFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingCategory}
                isSubmitting={isSubmitting}
                categories={categories}
            />
        </Space>
    )
}
